<div class="detail-card">
    <div class="detail-header">
        <div class="detail-header__bar">
            <h2 mat-dialog-title class="detail-header__date">
                {{ ticket?.calendarEvent?.time_start | date : "dd/MM/yyyy" }}
            </h2>
            <button
                mat-icon-button
                mat-dialog-close
                class="detail-header__close"
                color="primary"
                aria-label="Chiudi"
            >
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <span class="fo-chip detail-status">
            <span
                class="detail-status__dot"
                [style.backgroundColor]="data.statusDetails.color"
            ></span>
            {{ data.statusDetails.label }}
        </span>
    </div>

    <mat-dialog-content class="detail-content">
        <div class="detail-list">
            <div class="detail-row" *ngIf="ticket?.service?.title">
                <span class="detail-row__label">Canale</span>
                <span class="detail-row__value">{{
                    ticket?.service?.title
                }}</span>
            </div>
            <div class="detail-row" *ngIf="ticket?.id">
                <span class="detail-row__label">Numero prenotazione</span>
                <span class="detail-row__value">{{ ticket?.id }}</span>
            </div>
            <div class="detail-row" *ngIf="ticket?.category?.category">
                <span class="detail-row__label">Categoria</span>
                <span class="detail-row__value">{{
                    ticket?.category?.category
                }}</span>
            </div>
            <div class="detail-row" *ngIf="ticket?.calendarEvent?.time_start">
                <span class="detail-row__label">Orario di prenotazione</span>
                <span class="detail-row__value">{{
                    ticket?.calendarEvent?.time_start | date : "HH:mm"
                }}</span>
            </div>
            <div class="detail-row" *ngIf="ticket?.operator?.userdata?.name">
                <span class="detail-row__label">Operatore</span>
                <span class="detail-row__value"
                    >{{ ticket?.operator?.userdata?.name }}
                    {{
                        ticket?.operator?.userdata?.surname | slice : 0 : 1
                    }}</span
                >
            </div>
            <div class="detail-row" *ngIf="ticket?.calendarEvent?.duration">
                <span class="detail-row__label">Durata</span>
                <span class="detail-row__value">{{
                    ticket?.calendarEvent?.duration
                }}</span>
            </div>
            <div *ngIf="ticket?.calendarEvent?.is_remote">
                <div class="detail-row">
                    <span class="detail-row__label">Modalità</span>
                    <span class="detail-row__value">A distanza</span>
                </div>
            </div>
            <div *ngIf="!ticket?.calendarEvent?.is_remote">
                <div class="detail-row">
                    <span class="detail-row__label">Modalità</span>
                    <span class="detail-row__value">In presenza</span>
                </div>
                <div class="detail-row" *ngIf="ticket?.calendarEvent?.city">
                    <span class="detail-row__label">Città</span>
                    <span class="detail-row__value">{{
                        ticket?.calendarEvent?.city
                    }}</span>
                </div>
                <div class="detail-row" *ngIf="ticket?.calendarEvent?.address">
                    <span class="detail-row__label">Indirizzo</span>
                    <span class="detail-row__value">{{
                        ticket?.calendarEvent?.address
                    }}</span>
                </div>
                <div
                    class="detail-row"
                    *ngIf="ticket?.calendarEvent?.in_place_reason"
                >
                    <span class="detail-row__label"
                        >Motivazione della richiesta</span
                    >
                    <span class="detail-row__value">{{
                        ticket?.calendarEvent?.in_place_reason
                    }}</span>
                </div>
            </div>
        </div>

        <section class="detail-note">
            <h3 class="detail-note__title">Informazioni Utili</h3>
            <ul class="detail-note__list">
                <li>
                    Sarà possibile connettersi alla video-chiamata con il tasto
                    “partecipa”, attivo dall’orario dell’appuntamento in poi.
                </li>
                <li>
                    Si prega di essere puntuali e preparare tutta la
                    documentazione necessaria per la buona riuscita della
                    chiamata.
                </li>
                <li>
                    Per avvisare di un eventuale ritardo inviare una mail a
                    <a class="detail-note__link" [href]="'mailto:' + email">{{
                        email
                    }}</a>
                    con oggetto:<br />
                    “Ritardo appuntamento prenotazione numero .... ”
                </li>
                <li>
                    Se non si avvisa del ritardo, dopo 15 minuti dall'orario di
                    prenotazione del servizio, l'interprete è autorizzato a
                    chiudere la chiamata.
                </li>
            </ul>
            <p class="detail-note__foot">
                Per qualsiasi info e chiarimento rimaniamo a vostra completa
                disposizione
            </p>
        </section>

        <div class="detail-actions">
            <button
                type="button"
                class="fo-btn fo-btn--primary fo-btn--block"
                *ngIf="ticket.id_status === statusesTicket.ONLINE"
                (click)="goToVideochat(ticket)"
            >
                Partecipa
            </button>
            <button
                type="button"
                class="fo-btn fo-btn--danger fo-btn--block"
                *ngIf="
                    canDeleteTicket && ticket.id_status !== statusesTicket.ONLINE
                "
                (click)="onDeleteEvent(ticket)"
            >
                Cancella
            </button>
            <button
                type="button"
                class="fo-btn fo-btn--block"
                *ngIf="
                    !canDeleteTicket &&
                    ticket.id_status !== statusesTicket.ONLINE
                "
                disabled
            >
                Partecipa
            </button>
            <p class="detail-actions__hint">
                Le prenotazioni possono essere cancellate <br />
                entro e non oltre {{ hoursBeforeDeletion }} ore prima
                dell’evento
            </p>
        </div>
    </mat-dialog-content>
</div>
